import styled from 'styled-components';
import { colors } from '../../utils/colors';
import { Container } from '../common';
import { SocialNetworks } from '../social-networks/social-networks';

const FooterWrapper = styled.footer`
  background: ${colors.textDark};
  color: ${colors.white};
  padding: 4rem 0 2rem;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  margin-bottom: 3rem;
`;

const FooterSection = styled.div`
  h3 {
    color: ${colors.primary};
    margin-bottom: 1.5rem;
    font-size: 1.2rem;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 0.75rem;
  }

  a {
    color: ${colors.white};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${colors.primary};
    }
  }

  p {
    margin-bottom: 0.75rem;
    line-height: 1.6;
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.9rem;
  color: ${colors.textLight};
`;

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <FooterWrapper>
      <Container>
        <FooterContent>
          <FooterSection>
            <h3>Sobre Mí</h3>
            <p>
              Psicóloga especializada en terapia cognitivo-conductual y EMDR, ofrezco atención presencial y online para adolescentes y adultos, acompañando su bienestar emocional y crecimiento personal.
            </p>
            <SocialNetworks margin="2rem 0 0" />
          </FooterSection>

          <FooterSection>
            <h3>Enlaces Rápidos</h3>
            <nav aria-label="Enlaces del pie de página">
              <ul>
                <li>
                  <a href="#inicio">Inicio</a>
                </li>
                <li>
                  <a href="#sobre-mi">Sobre Mí</a>
                </li>
                <li>
                  <a href="#servicios">Servicios</a>
                </li>
                <li>
                  <a href="#faq">FAQ</a>
                </li>
                <li>
                  <a href="#contacto">Contacto</a>
                </li>
                <li>
                  <a href="#testimonios">Testimonios</a>
                </li>
              </ul>
            </nav>
          </FooterSection>

          <FooterSection>
            <h3>Contacto</h3>
            <ul>
              <li>
                <a 
                  href="tel:+59891288376"
                  aria-label="Llamar al teléfono +598 91 288 376"
                >
                  <i className="fa-solid fa-phone" aria-hidden="true"></i>
                  {' '}+598 91 288 376
                </a>
              </li>
              <li>
                <a 
                  href="mailto:psicologa.andrea.davila@gmail.com"
                  aria-label="Enviar email a psicologa.andrea.davila@gmail.com"
                >
                  <i className="fa-solid fa-envelope" aria-hidden="true"></i>
                  {' '}psicologa.andrea.davila@gmail.com
                </a>
              </li>
              <li>
                <address>
                  <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                  {' '}Presencial: Pocitos, Montevideo, Uruguay
                </address>
              </li>
              <li>
                <address>
                  <i className="fa-solid fa-globe" aria-hidden="true"></i>
                  {' '}Online: Sin restricciones geográficas
                </address>
              </li>
            </ul>
          </FooterSection>
        </FooterContent>

        <FooterBottom>
          <p>
            © {year} Psicóloga Andrea Dávila. Todos los derechos reservados.
          </p>
        </FooterBottom>
      </Container>
    </FooterWrapper>
  );
};
